export const daysOfWeek = [
  {
    value: 'SUNDAY',
    id: 0
  },
  {
    value: 'MONDAY',
    id: 1
  },
  {
    value: 'TUESDAY',
    id: 2
  },
  {
    value: 'WEDNESDAY',
    id: 3
  },
  {
    value: 'THURSDAY',
    id: 4
  },
  {
    value: 'FRIDAY',
    id: 5
  },
  {
    value: 'SATURDAY',
    id: 6
  }
];



// WEBPACK FOOTER //
// ./src/app/config/consts.ts